import React from 'react'

import CustomerAnalyticOverview from "components/Dashboard/Customer/CustomerAnalyticOverview"
import DashboardHeading from "components/Dashboard/DashboardHeading"
import DashboardContainer from "components/Dashboard/DashboardContainer"
import { useGetCustomerDashboardStatsQuery } from "store/services/dashboardApi"
import { useAppMeta } from "hooks"
import CustomerShipmentPerformanceScreen from "./components/customers/CustomerShipmentPerformanceScreen"



const CustomerDashboardScreen = () => {
  const { data: fetchStatsData, isLoading: statsDataLoading, isFetching: fetchingDashboard }
    = useGetCustomerDashboardStatsQuery();

  useAppMeta("Dashboard");

  return (
    <>
      <DashboardContainer>
        <div >
          <DashboardHeading />
        </div>

        {/* Analytics Overview */}
        <div>
          <CustomerAnalyticOverview
            statsData={fetchStatsData}
            isLoading={statsDataLoading || fetchingDashboard}
          />
        </div>

  {/* performance */}
        <div>
          <CustomerShipmentPerformanceScreen />
        </div>
      </DashboardContainer>
    </>
  )
}

export default CustomerDashboardScreen